import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import Sidebar from "../components/ui/Sidebar";
import QRCard from "../components/qr";
import MobileNBottomNav from "../components/ui/MobileBottomNav";

export default function Me() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState("qr");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    switch (page) {
      case "home":
        navigate("/loggedinartist");
        break;
      case "calendar":
        navigate("/bookevent");
        break;
      case "qr":
        navigate("/me");
        break;
      case "profile":
        navigate("/artistprofile");
        break;
      default:
        break;
    }
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-white via-[#F8F4FB] to-[#F0EBF5] w-screen relative md:mt-0 mt-20">
      <MobileNBottomNav />

      {/* Mobile Header */}
      <div className="fixed top-0 left-0 z-50 w-full px-2 py-3 flex items-center justify-between bg-logo backdrop-blur-sm lg:hidden">
        <div className="flex items-center gap-2">
          <img alt="" src="/images/tringbox-logo.png" className="h-6" />
        </div>

        <motion.button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="p-2 rounded-md"
          aria-label="Toggle sidebar"
        >
          {isSidebarOpen ? (
            <X size={24} className="text-white" />
          ) : (
            <Menu size={24} className="text-white" />
          )}
        </motion.button>
      </div>

      {/* Sidebar */}
      <div
        className={`fixed left-0 top-0 w-80 h-full z-20 transition-transform duration-300 ease-in-out lg:translate-x-0 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <Sidebar currentPage={currentPage} onPageChange={handlePageChange} />
      </div>

      {/* Main Content */}
      <main className="flex-1 min-h-screen lg:pl-80 flex flex-col w-full">
        <div className="flex-1 flex items-center justify-center w-full">
          <QRCard />
        </div>
      </main>
    </div>
  );
}
